<script setup lang="ts">
import type { SiteBlockData, SiteBlockSettings } from '~/types/types'

/**
 * Job openings list — entries live in block data for now; a `source:
 * "model"` mode can be added if a jobs/ATS feature lands later.
 */
const props = defineProps<{ data: SiteBlockData, settings: SiteBlockSettings }>()

const { t } = useI18n()
const jobs = computed(() => props.data.jobs ?? [])
const open = ref<number | null>(null)
</script>

<template>
  <div
    v-if="jobs.length"
    class="divide-y divide-[var(--site-border)] border-y border-[var(--site-border)]"
  >
    <div
      v-for="(job, i) in jobs"
      :key="i"
      class="py-4"
    >
      <button
        type="button"
        class="flex w-full items-center justify-between gap-4 text-left"
        @click="open = open === i ? null : i"
      >
        <span>
          <span class="block font-semibold">{{ job.title }}</span>
          <span class="mt-0.5 block text-sm text-[var(--site-muted)]">
            <template v-if="job.location">{{ job.location }}</template>
            <template v-if="job.location && job.employment_type"> · </template>
            <template v-if="job.employment_type">{{ job.employment_type }}</template>
          </span>
        </span>
        <UIcon
          :name="open === i ? 'i-lucide-minus' : 'i-lucide-plus'"
          class="size-5 shrink-0 text-[var(--site-muted)]"
        />
      </button>
      <div
        v-if="open === i"
        class="mt-3 space-y-3"
      >
        <div
          v-if="job.description"
          class="text-sm leading-relaxed text-[var(--site-muted)] [&_p]:my-2 [&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5"
          v-html="job.description"
        />
        <a
          v-if="job.apply_url"
          :href="job.apply_url"
          target="_blank"
          rel="noopener"
          class="site-btn-accent inline-block px-4 py-2 text-sm font-semibold"
        >
          {{ t('site.jobs_apply') }} →
        </a>
      </div>
    </div>
  </div>
</template>
